import React from 'react';
import Carousel from 'shared/components/carousel';
import {getBucketColleges, RecommendationBucketProps} from 'src/components/RecommendationBucket';
import HorizontalCollegeCard from 'src/components/HorizontalCollegeCard/HorizontalCollegeCard';
import {RecommendedCollege} from 'src/services/RecommendationsService';
import {useSelector} from 'react-redux';
import {Store} from 'src/types/store';
import styles from './styles.module.scss';

export default function SponsoredCollegesRecommendationBucket(props: RecommendationBucketProps) {
  const recommendation = props.recommendationBucket;
  const colleges = useSelector<Store, RecommendedCollege[]>(
    getBucketColleges(recommendation.collegeIds)
  );
  const showBasicContainer = recommendation.collegeIds.length < 2;
  const cards = colleges.map((college) => (
    <HorizontalCollegeCard
      className={styles.card}
      key={`card-${recommendation.id}-${college._id}`}
      college={college}
      followCollege={props.followCollege}
      recommendationId={recommendation.id}
      unfollowCollege={props.unfollowCollege}
      baseProps={{showBadge: true}}
      events={{
        recommendationsShownId: props.recommendationsShownId,
        bucketEventId: recommendation.bucketShownEventId,
      }}
    />
  ));

  return (
    <section data-testid="recommendation-section">
      <header>
        <h2 className={styles.title}>{recommendation.title}</h2>
        <p className={styles.subtitle}>{recommendation.description}</p>
      </header>
      {showBasicContainer ? (
        <div className="college-search-buckets-bucket-cards">{cards}</div>
      ) : (
        <Carousel>{cards}</Carousel>
      )}
    </section>
  );
}
